'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:inject:addStopUrl');
}

var _invoke = require('../invoke');

/**
 * 匹配隐藏 webview 页面的 url
 *
 * 符合时，停止页面加载并执行脚本
 * 只匹配一次？
 *
 * TODO: 支持版本
 *
 * 支持版本
 * + iHotel/5.9?
 *
 * @memberof inject
 * @static
 * @name addStopUrl
 * @param {String} name 隐藏 webview 名
 * @param {String} pattern 用于匹配 url 的正则
 * @param {String} script 匹配后执行的命令
 * @return {Promise}
 * @example
 *  hbnb.inject.addStopUrl('name', 'pattern', 'script')
 *      .then(function() {
 *          console.log('loaded');
 *      });
 */
module.exports = function(name, pattern, script) {
    if (process.env.NODE_ENV !== 'production') {
        debug('name is %s', name);
        debug('pattern is %s', pattern);
        debug('script is %s', script);
    }

    var p = new Promise(function(resolve, reject) {
        _invoke('inject', 'add_stop_url', {
            name: name,
            pattern: pattern,
            script: script,
            callback: function() {
                resolve();
            }
        });
    });
    return p;
};



//////////////////
// WEBPACK FOOTER
// ./~/@hfe/hbnb/inject/add-stop-url.js
// module id = 183
// module chunks = 0 8 9